import CollectionCard from "Component/Collection/CollectionCard";
import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
import CategoryCard from "Pages/category/categoryCard";
import React, { useState, useEffect } from "react";
import { Oval } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Col, Container, Input, Row } from "reactstrap";
import { allsellItemFromCollectionId, getNewCollectionByIdStart } from "store/actions";

export default function NftView(props) {
  const [tabs, settabs] = useState('Fixed')
  const dispatch = useDispatch()
  const { id } = useParams()
  const { allSellItemFromCollection } = useSelector((state) => state?.SellItems)
  const { collection } = useSelector((state) => state?.collections)
  const [fixedData, setFixedData] = useState([])
  const [search, setSearch] = useState('')
  const [data, setData] = useState([])
  const backto = () => {
    window.history.back()
  }

  useEffect(() => {
    if (tabs === "Fixed") {
      const data = allSellItemFromCollection?.filter((item) => item?.nft_id?.saleType === "fixed")
      setFixedData(data)

    } else {
      const data = allSellItemFromCollection?.filter((item) => item?.nft_id?.saleType === "auction")
      setFixedData(data)

    }
  }, [allSellItemFromCollection, tabs])


  useEffect(() => {
    let data = {}
    data.collection_id = id
    dispatch(allsellItemFromCollectionId(data))
  }, [id])

  useEffect(() => {
    if (search === '') {
      setData(fixedData)
    }
    else {
      setData(fixedData?.filter((item) => { return search?.toLowerCase() === '' ? item : item?.nft_id?.name?.toLowerCase()?.includes(search?.toLowerCase()) }))
    }
  }, [fixedData, search])


  const Artisttabs = async (data) => {
    switch (data) {
      case 'Fixed':
        settabs('Fixed')
        break;
      case 'auction':
        settabs('auction')
        break;
      default:
        settabs('Fixed')
    }
  }
  const handleSearch = (value) => {
    setSearch(value)
  }
  useEffect(() => {
    if (id) {
      dispatch(getNewCollectionByIdStart(id))
    }
  }, [id, dispatch])
  const [setOvalLaoding, ovalLaoding]= useState(false)
  return (<>
      {(ovalLaoding===true) &&(
        <div className="loaderBoxMiane">
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}
      <Header />
      <div className="container-fluid profileBox nftview">
        <Row>
          <Col lg={12}>
            <h1><div className="d-inline  cursor-pointer">{collection?.name} </div> </h1>
          </Col>
        </Row>
      </div>
      <Container>
        <Row>
          <Col md={12}>
            <div className="collectionProfile position-relative mt-4">

              <div className="profileCollection">

                <div className="profilecollCont">

                  <p className="scrollheight"> {collection?.description}</p>

                </div>
              </div>

            </div>
          </Col>
        </Row>
        <Row className="py-5 ">
          <Col lg={12}>
            <div className="artTab mb-4">
              <ul>
                <li onClick={() => Artisttabs('Fixed')} className={tabs === 'Fixed' ? 'active' : ''}>Fixed</li>
                <li onClick={() => Artisttabs('auction')} className={tabs === 'auction' ? 'active' : ''}  >Auction</li>
              </ul>
            </div>
            <Row className="justify-content-between searchcoll mb-4">
              <Col className="mb-3" lg={6}>
                <div className="position-relative ">
                  <Input
                    className="form-control searchInput "
                    placeholder="Search for Artworks"
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <button className="btn position-absolute end-0 top-0 bottom-0 my-auto border-0">
                    <i className="fa-light fa-magnifying-glass"></i>
                  </button>
                </div>
                {/* <p className="pdecription pdecriptioncol text-start">Showing 350 NFT's</p> */}
              </Col>
              {/* <Col  lg={4}>
                <div className="d-flex align-item-center gap-3">
                  <Input
                    type="select"
                    className="form-control searchInput shadow-none"
                  >
                    <option>Low to High</option>
                    <option>High to Low</option>
                  </Input>
                  <Input
                    type="select"
                    className="form-control searchInput shadow-none"
                  >
                    <option>DAILY</option>
                    <option>WEEKLY</option>
                  </Input>
                  <button className="btn border-0 clearfilter p-0">
                    <i className="fa-solid fa-filter-circle-xmark"></i>
                  </button>
                </div>
              </Col> */}
            </Row>
            <Row>

              {data.length > 0 ? (
                <>
                  {data?.map((nftData, idx) => {
                    return (
                      <Col className="mb-4" lg={3} key={idx}>
                        <CategoryCard data={nftData} />
                      </Col>
                    )
                  })}
                </>
              ) : (
                <>
                  <div className="text-center d-grid justify-content-center dataNotFound py-5">
                    <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
                    <h3>No Artworks Available</h3>
                  </div>
                </>
              )}

            </Row>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}
